
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curl-jung-debates",
      function () {
        return require("private-next-pages/curl-jung-debates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curl-jung-debates"])
      });
    }
  